"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationDashboardData = void 0;
const models_1 = require("../../products/models");
const responses_1 = require("../../sales-order/responses");
const product_implementation_model_1 = require("./../models/product-implementation.model");
class ProductImplementationDashboardData {
}
exports.ProductImplementationDashboardData = ProductImplementationDashboardData;
//# sourceMappingURL=product-implementation-dashboard-data.response.js.map